import axios from "axios";
const loginUrl = "rest/j_spring_security_check/";
const registrationUrl = "rest/register";

export const requestLoginRegistration = (authData, action, isLogin) => {
	const url = action === "login" ? loginUrl : registrationUrl;

	return axios({
		method: "post",
		url: `${ocm.config.encodedContextPath}/${url}`,
		headers: {
			csrftoken: authData.CSRFToken,
		},
		data: `j_username=${encodeURIComponent(authData.j_username)}&j_password=${encodeURIComponent(
			authData.j_password
		)}&rememberMe=${authData.rememberMe}&g-recaptcha-response=${authData.g_recaptcha_response}`,
	}).then((response) => {
		localStorage.setItem("loginTabActive", true); // todo: TUB-14107
		// fix für TUB-15305 und TUB-15607
		const useRedirectURL = !isLogin || document.body.classList.contains("page-LogoutPage");
		useRedirectURL ? location.assign(response.data.redirectUrl) : location.reload();
	});
};

// HTTP-Status 404, wenn keine Komponente gepflegt ist oder aufgrund von Restrictions nicht ausgeliefert wird
export const fetchLabels = () => axios(`${ocm.config.encodedContextPath}/rest/login-layer/content`);
